import React from 'react';
import styled from 'styled-components';
import { videoSort } from '../../util/constants';
import { SortTextButton, HEADING_STYLE } from '../sortTextButton';
import { Box } from 'rebass';
import { videoGrid } from '../../util/ui';

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

const Bar = styled.div`
  box-sizing: border-box;
  /* UI refresh: neutral charcoal instead of dark green, so green only ever means "complete". */
  background-color: #2e333b;
`;

const InputContainer = styled.div<{ width: string }>`
  width: ${(p) => p.width};
  min-width: ${(p) => (p.width === '100%' ? '150px' : p.width)};
  box-sizing: border-box;
`;

const Empty = styled.div<{ width: string }>`
  width: ${(p) => p.width};
  min-width: ${(p) => p.width};
`;

const Divider = styled.div`
  width: ${(p) => p.theme.space[2]}px;
  min-width: ${(p) => p.theme.space[2]}px;
`;

type Props = {
  currentSort: { sortType: videoSort; direction: 'asc' | 'desc' };
  update(sortType: videoSort, direction: 'asc' | 'desc'): void;
};

export const VideoSortBar: React.FC<Props> = ({ currentSort, update }) => {
  const updateSort = (sortType: videoSort, direction: 'desc' | 'asc') => {
    update(sortType, direction);
  };
  const checkState = (sortType: videoSort): 'asc' | 'desc' | undefined => {
    return currentSort.sortType === sortType ? currentSort.direction : undefined;
  };
  // Same column layout as the file rows (util/ui VIDEO_COLUMNS), so every heading sits over its column.
  return (
    <Container>
      <Bar style={{ ...videoGrid, height: 32 }}>
        <span />
        <SortTextButton
          text={'Filename'}
          onClick={(direction) => updateSort(videoSort.filename, direction)}
          state={checkState(videoSort.filename)}
        />
        <span style={HEADING_STYLE}>Notes</span>
        <SortTextButton
          text={'Type'}
          onClick={(direction) => updateSort(videoSort.ext, direction)}
          state={checkState(videoSort.ext)}
        />
        <SortTextButton
          text={'Size'}
          onClick={(direction) => updateSort(videoSort.size, direction)}
          state={checkState(videoSort.size)}
        />
        <SortTextButton
          text={'Label'}
          onClick={(direction) => updateSort(videoSort.category, direction)}
          state={checkState(videoSort.category)}
        />
        <SortTextButton
          text={'Date'}
          onClick={(direction) => updateSort(videoSort.date, direction)}
          state={checkState(videoSort.date)}
        />
        <span />
      </Bar>
    </Container>
  );
};
